import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./NewAccount.css";
import Navbar from "../../shared/Navbar";
import { GET_NEW_ACCOUNTS_URL } from "../../api/apiurls";
import { AuthContext } from "../../ContextApi/ContextApi";
const AccountCards = () => {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userName } = useContext(AuthContext);

  useEffect(() => {
    if (!userName) {
      // No agent available yet — show empty state
      setAccounts([]);
      setLoading(false);
      return;
    }

    fetchAccounts();
  }, [userName]);

  const fetchAccounts = async () => {
    try {
      setLoading(true);

      const res = await fetch(GET_NEW_ACCOUNTS_URL);
      if (!res.ok) throw new Error("Failed to fetch");

      const data = await res.json();
      const list = data || [];
      // Filter by agent from context
      const filtered = list.filter((acc) => acc.AgentName === userName);
      setAccounts(filtered);
      console.log("Fetched Accounts (raw):", list);
      console.log("Filtered Accounts (by agent):", filtered);
    } catch (err) {
      console.error("Fetch Error :", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="newaccount-navbar-spacing">
        <div className="newaccount-container">

          <div className="newaccount-header">
            <h2>New Accounts</h2>

            <button
              className="newaccount-print-btn"
              onClick={() =>
                navigate("/newaccount-report-bluetooth", {
                  state: { accounts },
                })
              }
              disabled={!accounts.length}
            >
              Print
            </button>
          </div>

          <div className="newaccount-cards-wrapper">
            {loading ? (
              <p className="newaccount-no-data">Loading...</p>
            ) : accounts.length ? (
              accounts.map((acc, index) => (
                <div className="newaccount-card" key={index}>
                  <p><strong>Account No:</strong> {acc.AccountNo}</p>
                  <p><strong>Name:</strong> {acc.Name}</p>
                  <p><strong>Account Type:</strong> {acc.AccountType}</p>
                  <p><strong>Date:</strong> {acc.OpenDate}</p>
                  <p><strong>Received Amount:</strong> ₹{acc.Recieved}</p>
                </div>
              ))
            ) : (
              <p className="newaccount-no-data">No accounts found!</p>
            )}
          </div>

        </div>
      </div>
    </>
  );
};

export default AccountCards;
